module.exports = __webpack_public_path__ + "img/slide2.6271fc52.png";